import React from 'react';
import WaitingListTab from './WaitingListTab';

export default function DotnetTab() {
  return <WaitingListTab languageKey="dotnet" languageName=".NET" />;
}
